/*
 * Confidential and Proprietary.
 * Do not distribute without Bloom Harbor Gifts consent.
 * Copyright Bloom Harbor Gifts 2019. All rights reserved.
 */

import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { string, bool, array } from 'prop-types';

import Media from 'react-media';
import Star from '@material-ui/icons/Star';
import StarHalf from '@material-ui/icons/StarHalf';

import ResponsiveImage from '../../../GraphqlCommonComponents/ResponsiveImage/ResponsiveImage';

const useStyles = makeStyles((theme) => ({
    passportEligibleImage: {
        width: '24%',
        [theme.breakpoints.down('md')]: {
            width: '45%',
            marginBottom: '10px',
        },
        [theme.breakpoints.down(600)]: {
            display: 'block',
            width: '38%',
            margin: '0 auto 5px',
        },
    },
    plaEnabledProductTitle: {
        display: 'block',
        justifyContent: 'space-between',
        [theme.breakpoints.down(600)]: {
            display: 'flex',
            alignItems: 'center',
            padding: '0 20px',
        },
    },
    simpleProductTitle: {
        display: 'flex',
        flexDirection: 'column',
    },
    plaEnabledPassportImage: {
        width: '100px',
        [theme.breakpoints.down('md')]: {
            width: '45%',
        },
        [theme.breakpoints.down(600)]: {
            width: '100%',
        },
    },
    productName: {
        width: '100%',
        marginTop: 0,
        marginBottom: 0,
        fontSize: '24px',
        [theme.breakpoints.down('md')]: {
            marginBottom: '10px',
        },
        [theme.breakpoints.down(767)]: {
            display: 'none',
        },
    },
    foodProductName: {
        [theme.breakpoints.down(767)]: {
            display: 'block',
        },
    },
    passportProductName: {
        margin: 0,
        [theme.breakpoints.down(600)]: {
            display: 'none',
        },
    },
    bottomContent: {
        display: 'flex',
        alignItems: 'center',
        width: '80%',
    },
    ratingStars: {
        display: 'inline-block',
        margin: '0 8px 0 8px',
        height: '19px',
        '& svg': {
            width: '12px',
            height: '11px',
            color: theme.palette.cms?.ratingStarsColor || '#000000',
        },
    },
    productRatingContainer: {
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        margin: '0 0 10px',
        [theme.breakpoints.down(600)]: {
            justifyContent: 'flex-end',
            margin: 0,
        },
    },
    reviewCountContainer: {
        display: 'flex',
        alignItems: 'center',
        height: '10px',
    },
    reviewCount: {
        display: 'inline-block',
        color: theme.palette.cms?.reviewCountColor || '#B6B6B6',
        fontSize: '11px',
        lineHeight: '14px',
    },
    shopperApproveIcon: {
        width: '70px',
        height: '18px',
        marginLeft: '10px',
        [theme.breakpoints.down(600)]: {
            width: '90px',
            height: '30px',
        },
    },
}));

const PLAProductTitle = ({
    isPlaEnabled,
    presentationFamily,
    productName,
    isPassportBannerEnabled,
    skuEnabledOnMobile,
    // partNumber,
}) => {
    const classes = useStyles();
    const foodBrandClass = (presentationFamily === 'food' && skuEnabledOnMobile) ? classes.foodProductName : '';
    let getDonationPageUrl;
    if (typeof window !== 'undefined') {
        getDonationPageUrl = window.location.pathname.includes('/donation-192399');
    }

    const renderPassportImage = () => {
        if (presentationFamily === 'flower' && isPassportBannerEnabled && !getDonationPageUrl) {
            return (
                <ResponsiveImage
                    className={isPlaEnabled ? classes.plaEnabledPassportImage : classes.passportEligibleImage}
                    path="https://images.contentstack.io/v3/assets/bltdd99f24e8a94d536/blt8d4549d3cac15860/61e09d4f2e109d6c649d4aa4/PP_EligibleIcon.svg"
                    alt="Passport Eligible"
                />
            );
        }
        return null;
    };

    return (
        <>
            <div className={isPlaEnabled ? classes.plaEnabledProductTitle : classes.simpleProductTitle} aria-hidden="true">
                <h1 className={isPlaEnabled && !isPassportBannerEnabled ? `${classes.passportProductName} ${foodBrandClass}` : `${classes.productName} ${foodBrandClass}`}>{productName}</h1>
                <div className={classes.bottomContent}>
                    {isPlaEnabled && renderPassportImage()}
                    <div className={classes.productRatingContainer}>
                        <Media
                            query="(min-width: 600px)"
                            render={() => (
                                <div className={classes.reviewCountContainer}>
                                    <div className={classes.ratingStars}>
                                        <Star />
                                        <Star />
                                        <Star />
                                        <Star />
                                        <StarHalf />
                                    </div>
                                    <p className={classes.reviewCount}>254,268 reviews</p>
                                </div>
                            )}
                        />
                        <div className={classes.shopperApproveContainer}>
                            <img src="https://images.contentstack.io/v3/assets/bltdd99f24e8a94d536/bltab0819c5ba8dff60/5e28ea9fe2b3975498eaf8d3/salogo.png" className={classes.shopperApproveIcon} alt="Shopper Approved Logo" />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

PLAProductTitle.propTypes = {
    isPassportBannerEnabled: bool.isRequired,
    isPlaEnabled: bool.isRequired,
    presentationFamily: string.isRequired,
    productName: array.isRequired,
    skuEnabledOnMobile: bool,
};

PLAProductTitle.defaultProps = {
    skuEnabledOnMobile: false,
};

export default PLAProductTitle;
